import {
  GetString,
} from 'fluent-react';
import React from 'react';
import styled from 'styled-components';
import { ProductClass, QueryLevel, TradeDirection } from '../../graphQL/types/shared';
import {
  TradeFlow,
} from '../../graphQL/types/shared';
import { extractFromStringLocationId } from '../../graphQL/Utils';
import { useLink } from '../../routing';
import { RouteID } from '../../routing/routes';
import {
  Target,
} from '../../Utils';

import { googleAnalyticsEvent } from '../../useGoogleAnalytics';
import { QueryStore } from '../../viz/queryStoreUtils';
import { convertQueryStoreIntoQueryParams } from '../../viz/routingUtils';
import {
  NodeSizing, VizType,
} from '../../viz/Utils';
import { smallMediaQuery } from '../Grid';
import { primaryColor1 } from '../Utils';
import {
  Container,
  SvgContainer,
  svgHeight,
  svgWidth,
} from './sharedStyling';

const NewTabArrow = styled.div`
  position: absolute;
  bottom: 0;
  right: 0.6rem;
  width: 0.825rem;

  svg {
    width: 100%;
    height: 100%;
  }

  @media ${smallMediaQuery} {
    right: 2px;

    svg {
      width: 50%;
      height: 50%;
    }
  }
`;

const MagnifyingGlass = styled(SvgContainer)`
  svg {
    width: ${svgWidth}px;
    height: ${svgHeight}px;
  }

  @media ${smallMediaQuery} {
    svg {
      width: ${svgWidth / 2}px;
      height: ${svgHeight / 2}px;
    }
  }
`;

const Link = styled.a`
  color: white;
  font-size: 1.5rem;
  text-transform: uppercase;
  line-height: 1.5;
  padding: 1.2rem 1.5rem;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: ${primaryColor1};
  width: 100%;
  height: 100%;

  svg {
    fill: white;
  }

  &:hover {
    background: white;
    color: ${primaryColor1};

    svg {
      fill: ${primaryColor1};
    }
  }

  @media ${smallMediaQuery} {
    font-size: 0.6rem;
    padding: 0.6rem;
  }
`;

interface Props {
  year: number;
  countryId: string;
  getFluentString: GetString;
}

const ExploreButton = (props: Props) => {
  const {
    year, countryId, getFluentString,
  } = props;

  const locationIDNumber = extractFromStringLocationId(countryId);
  const newState: QueryStore = {
    country: locationIDNumber,
    queryLevel: QueryLevel.Location,
    product: undefined,
    year,
    startYear: undefined,
    tradeDirection: TradeDirection.export,
    productClass: ProductClass.HS,
    nodeSizing: NodeSizing.None,
    tradeFlow: TradeFlow.Gross,
    target: Target.Product,
    partner: undefined,
  };
  const linkProps = useLink({
    id: RouteID.TreeMap,
    queryParams: convertQueryStoreIntoQueryParams(VizType.Tree, newState),
  });

  return (
    <Container>
      <Link
        href={`/explore?exporter=country-${countryId.split('-')[1]}`}
        target='_blank'
        onClick={() => googleAnalyticsEvent(
          'Country Profiles Conclusion Explore Further',
          'click -- explore further in Atlas',
        )}
      >
        <MagnifyingGlass
            dangerouslySetInnerHTML={{__html: require('../topProductsTable/magnifying-glass-plus.svg')}}
        />
        <span>
          {getFluentString('conclusion-slide-text-explore-country-in-atlas')}
        </span>
        <NewTabArrow
          dangerouslySetInnerHTML={{__html: require('../topProductsTable/diagonal-right-arrow.svg')}}
        />
      </Link>
    </Container>
  );
};

export default ExploreButton;
